
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useAvatarLayerEdit } from '@/modules/avatar/layer/model/edit';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.LAYER.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useAvatarLayerEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions };
    }
});
